import { useMemo } from 'react';

import filter from '@Components/Grid/utils/filter';

export default function useFilters() {
  return useMemo(() => [
    filter
      .options.list('integration_type', 'Type', TYPE_OPTIONS)
      .multi(true),
    filter
      .options.list('vendor', 'Vendor', VENDOR_OPTIONS)
      .multi(true),
    filter.boolean('active', 'Active'),
  ], [])
}

const TYPE_OPTIONS = [
  { label: "Register", value: "register" },
  { label: "Unsubscribe", value: "unsubscribe" },
  { label: "Delayed Registration", value: "delayed_register" },
  { label: "Opt-Out", value: "optout" },
  { label: "Sweeps Contest Finished", value: "contest_finish" },
  { label: "Sweeps E-mail Confirmation", value: "sweeps_confirmation" },
  { label: "Sweeps Ticket Confirmation", value: "sweeps_confirmation_ticket" },
  { label: 'Revenue Postback', value: 'revenue_postback' },
  { label: 'Revenue Poller', value: 'revenue_poller' },
  { label: 'Revenue Share', value: 'revenue_share' },
  { label: 'Path Impression', value: 'path_impression' },
  { label: 'Path Ping/Post', value: 'path_ping_post' },
  { label: 'Lead Status Sync', value: 'lead_status_sync' },
]

const VENDOR_OPTIONS = [
  { label: "Twyne", value: "twyne" },
  { label: "Twyne Direct Post", value: "twyne_direct_post" },
  { label: "Wishpond", value: "wishpond" },
  { label: "Aweber", value: "aweber" },
  { label: "All Inbox", value: "aib" },
  { label: "Sendlane", value: "sendlane" },
  { label: "Http GET", value: "http_get" },
  { label: "Http POST", value: "http_post" },
  { label: "Twyne optout", value: "twyne_optout" },
  { label: "Trusted form", value: "trusted_form" },
  { label: "Email", value: "email" },
  { label: "Secure FTP (SFTP)", value: "sftp" },
  { label: "FTP", value: "ftp" },
  { label: "Trusted form extend", value: "trusted_form_extend" },
  { label: "SCA", value: "sca" },
  { value: 'midpath', label: "Path" },
  { value: 'tcpa', label: "Survey / TCPA" },
  { value: 'registration', label: "Registration" },
  { value: 'delayed_registration', label: "Registration Delayed" },
  { value: 'email', label: "Email" },
  { value: 'pushnotification', label: "Push" },
  { value: 'retargeting', label: "Retargeting Pixels" },
  { value: 'callcenter', label: "Calls" },
  { value: 'twyne_registration', label: "Form Offers" },
  { value: 'clickwall', label: "ClickWall" },
  { value: 'exit', label: "Exit" },
  { value: 'adsense', label: "Adsense" },
  { value: 'cmspage', label: 'CMS Pages' },
  { value: 'reward_progression', label: 'Reward' },
]
